const tabStyle = {
  tab: {
    borderBottom: '2px solid #ababab',
    boderTop: "4px solid transparent",
    backgroundColor: '#343c47',
    borderLeft: '1px solid #515862',
    borderRight: '1px solid #515862',
    webkitTextFillColor: '#8d9aab',
    textTransform: 'capitalize',
  },
  selectedTab: {
    borderBottom: '2px solid transparent',
    borderTop: '4px solid #fff',
    borderLeft: '1px solid #ccc',
    borderRight: '1px solid #ccc',
    WebkitTextFillColor: '#ffffff',
    textTransform: 'capitalize',
  },
}

export { tabStyle };